import { useState, useRef } from 'react';
import {
  View,
  TouchableOpacity,
  StyleSheet,
  LayoutAnimation,
  Platform,
  UIManager,
  Animated,
  Linking,
} from 'react-native';
import { CaretUp, CaretDown } from '../../sharedComponents/Icons';
import gs from '../../styles/globalStyles';
import { themeColorSet, ThemedPressable, ThemedText, ThemedView } from '@app/theme';

if (Platform.OS === 'android' && UIManager.setLayoutAnimationEnabledExperimental) {
  UIManager.setLayoutAnimationEnabledExperimental(true);
}

interface AccordionProps {
  id: string;
  description?: string;
  title: string;
  children?: string[];
  link?: string;
}

const Accordion = ({ id, description, title,link }: AccordionProps) => {
  const [expanded, setExpanded] = useState(false);
  const [contentHeight, setContentHeight] = useState(0);
  const [measured, setMeasured] = useState(false);
  const animation = useRef(new Animated.Value(0)).current;

  const toggleExpand = () => {
    const finalValue = expanded ? 0 : contentHeight;

    Animated.timing(animation, {
      toValue: finalValue,
      duration: 300,
      useNativeDriver: false,
    }).start();

    setExpanded(prev => !prev);
  };

  const handleLinkPress = () => {
    if (link) {
      Linking.openURL(link);
    }
  };

  return (
    <ThemedView bg='bg-surface-primary' key={id}>
      <ThemedPressable 
        flexDirection='row' 
        justifyContent='space-between' 
        alignItems='center' 
        backgroundColor='bg-surface-primary'  
        onPress={toggleExpand}
      >
        <ThemedView flex={1}>
          <ThemedText variant='b3s' color='text-primary'>{title}</ThemedText>
        </ThemedView>
        {expanded ? (
          <CaretUp size={14} color={themeColorSet['icon-primary']} weight="bold" />
        ) : (
          <CaretDown size={14} color={themeColorSet['icon-primary']} weight="bold" />
        )}
      </ThemedPressable>

      {/* Animated container */}
      <Animated.View style={{ height: animation, overflow: 'hidden' }}>
        <View
          style={{ position: 'absolute', opacity: 0, zIndex: -1, width: '100%' }}
          pointerEvents="none"
          onLayout={e => {
            if (!measured) {
              setContentHeight(e.nativeEvent.layout.height);
              animation.setValue(expanded ? e.nativeEvent.layout.height : 0);
              setMeasured(true);
            }
          }}
        >
          <ThemedView mt='sm'>
            <ThemedText variant='b4r' color='text-secondary'>
              {description?.replace('${tenure}', '12')}
            </ThemedText>
          </ThemedView>
          {link && (
            <ThemedPressable onPress={handleLinkPress}>
              <ThemedText variant='b3b' color='text-action-primary' mt='xs' textDecorationLine='underline'>
                click here to raise data deletion request
              </ThemedText>
            </ThemedPressable>
          )}
        </View>
        {measured && (
          <ThemedView mt='sm'>
            <ThemedText variant='b4r' color='text-secondary'>
              {description?.replace('${tenure}', '12')}
            </ThemedText>
            {link && (
              <ThemedPressable onPress={handleLinkPress}>
                <ThemedText variant='b3b' color='text-action-primary' mt='xs' textDecorationLine='underline'>
                  click here to raise data deletion request
                </ThemedText>
              </ThemedPressable>
            )}
          </ThemedView>
        )}
      </Animated.View>

      <ThemedView height={1} bg='border-secondary' marginVertical='lg' />
    </ThemedView>
  );
};

export default Accordion;
